export enum EmailType {
    UserRegistration = 1,
	PasswordRecovery = 2,
	PurchaseConfirmation = 3,
	Contact = 4
}